import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Bluetooth: IconNode = [
  'svg',
  defaultAttributes,
  [['path', { d: 'm7 7 10 10-5 5V2l5 5L7 17' }]],
];

export default Bluetooth;
